import React, { createContext, useContext, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { fetchClientPlanTableAndFilterSchema } from "model/ClientPlanModel";
import { useCommonFilterOptions } from "./CommonFilterOptionsContext";

const ClientPlanContext = createContext();

export const ClientPlanProvider = ({ children }) => {
  const { fetchMetadataSchema } = useCommonFilterOptions();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [clientPlanContextData, setClientPlanContextData] = useState();
  const [clientPlanVersion, setClientPlanVersion] = useState();

  const fetchClientPlanContextData = async () => {
    setLoading(true);
    try {
      const response = await fetchMetadataSchema("metadata:clientPlan", () =>
        fetchClientPlanTableAndFilterSchema([])
      );
      if (response?.success) {
        setClientPlanContextData(response?.data);
        setClientPlanVersion(response?.schemaVersion);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchAll = async () => {
      await Promise.all([]);
    };
    fetchAll();
  }, []);

  return (
    <ClientPlanContext.Provider
      value={{
        fetchClientPlanContextData,
        clientPlanContextData,
        loading,
        error,
        clientPlanVersion,
      }}
    >
      {children}
    </ClientPlanContext.Provider>
  );
};

export const useClientPlanContext = () => useContext(ClientPlanContext);
